export default "__VITE_ASSET__Duq2RaiL__"